import { useEffect, useState } from "react";

export const Image: React.FC<{ src?: string; size?: number; }> = ({ src, size = 240 }) => {
    const [state, setState] = useState<{ src: string; width?: number; height?: number }>({
        // TODO: this should be an image in static, that we have permission to
        src: 'https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?s=612x612&w=0&k=20&c=BIbFwuv7FxTWvh5S3vB6bkT0Qv8Vn8N5Ffseq84ClGI=',

        // this assumes the default image is either a square or wider than tall
        width: size
    })
    useEffect(() => {
        if (src){
            const img = document.createElement('img');

            img.src = src

            img.addEventListener('load', () => {
                const { width, height } = img;
                if (width > height){
                    setState({ src, width: size });
                }
                else {
                    setState({ src, height: size });
                }
            })
        }

    }, [src, size]);

    return (
        <div style={{ width: size, height: size, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={state.src} style={{ width: state.width, height: state.height }} alt="" />
        </div>
    );
}
